const config = {
  dns: "lekkerland.reckon.ai",
  useLocale: true,
  buybyeURL: "https://buybye-testing.reckon.ai",
  changeLocale: true,
};

export default config;
